import { useState } from "react";
import { useFirestoreConnect, useFirestore } from "react-redux-firebase";
import { useSelector } from "react-redux";
import { useParams, Redirect } from "react-router-dom";

import Loading from '../components/Loading';
import UserForm from '../components/UserForm';
import Page from './Page';

const UserEdit = () => {
  const { userId } = useParams();
  const firestore = useFirestore();
  const [ isSuccess, setIsSuccess ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(false);
  const user = useSelector(state => state.firestore?.data?.users && state.firestore?.data?.users[userId])

  useFirestoreConnect([
    {
      collection: 'users',
      doc: userId
    },
  ]);

  const onSave = async (formData) => {
    setIsLoading(true);

    // remove all "undefined" fields
    Object.keys(formData).forEach(key => formData[key] === undefined ? delete formData[key] : {});

    try {
      await firestore.collection('users').doc(userId).set(formData, {merge: true});
      setIsSuccess(true);
    } catch (e) {
      console.error(e);
    }

    setIsLoading(false);
  }

  if(!isLoading && isSuccess) {
    return <Redirect to="/users" />
  }

  if (isLoading || !user) {
    return <Loading />
  }

  return (
    <Page title="Edit customer" action={<></>}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <UserForm user={user} onSave={onSave} />
          </div>
        </div>
      </div>
    </Page>
  )
}

export default UserEdit;
